import { useState, useCallback } from 'react'
import firebase from '../firebase/compat'
import { db } from '../firebase/config'

// AI-CONTEXT: See docs/patterns.md#data-analytics-pin-snapshot
// AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
//
// Eén keuze van een dashboardkaart die de kaart moet onthouden. Zonder
// `item` (de kaart is niet vastgezet) gedraagt het zich als gewone `useState`;
// mét `item` gaat elke wijziging ook naar het `DashboardItems`-document, zodat
// een vastgezette kaart bij de volgende keer openen nog steeds hetzelfde toont.
//
// Deze hook is uit `useLocationFilter` getrokken toen het statusfilter
// erbij kwam: twee keer hetzelfde schrijfrecept naast elkaar loopt vroeg of
// laat uiteen.

/**
 * @param {object|undefined} item - Het `DashboardItems`-document van de kaart
 *   (moet `docid` hebben). Zonder dit wordt er niets opgeslagen.
 * @param {string} field - Veldnaam op dat document, uit `DASHBOARD_FILTER_FIELDS`
 * @param {string} [defaultValue] - Waarde als het veld nog leeg is
 * @returns {[string, (next: string) => void]}
 */
const useDashboardCardSetting = (item, field, defaultValue = '') => {
    const [value, setLocalValue] = useState(item?.[field] ?? defaultValue)

    const setValue = useCallback((next) => {
        setLocalValue(next)
        if (item?.docid) {
            db.collection('DashboardItems').doc(item.docid).update({
                [field]: next,
                Timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item?.docid, field])

    return [value, setValue]
}

export default useDashboardCardSetting
